export default __webpack_public_path__ + "static/media/upgrade-report5.a07c09c1.png";